import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GeneralService } from 'src/services/general.service';
import { SweetAlertService } from 'src/services/sweet-alert.service';
import { Storage, ref, uploadBytes, getDownloadURL } from '@angular/fire/storage';
import { Router } from '@angular/router';
declare var menu: any;
@Component({
  selector: 'app-pasaporte',
  templateUrl: './pasaporte.component.html',
  styleUrls: ['./pasaporte.component.scss']
})

export class PasaporteComponent {
  boton: any;
  id: any;
  displayStyleEditar = "none";

  //Variables para url de archivos
  urlDocumento = '';

  //Variables para indicar carga de archivos
  subiendoDocumento = false;

  editarForm = new FormGroup({
    ID: new FormControl(''),
    ICONO: new FormControl(''),
    AREA: new FormControl(''),
    SUBAREA: new FormControl('')
  })

  menu: any;
  areas: any;
  areas1: any;
  area: any;
  subarea: any;
  archivos: string[] = [];

  constructor(private api: GeneralService, private alerts: SweetAlertService, private storage: Storage, private router: Router) { }

  ngOnInit(): void {

    if (localStorage.getItem('token')) {
      this.boton = 1;
    }

    this.api.verAreas().subscribe(res => {
      this.menu = res.body;
      console.log(this.menu);

    })

    this.api.verAreas1(2, 0).subscribe(res => {
      this.areas = res.body;
      console.log(this.areas);

    })

    this.api.verAreas1(2, 1).subscribe(res => {
      this.areas1 = res.body;
      console.log(this.areas1);

    })

  }

  openModalEditar(AREA: any, SUBAREA: any) {
    this.area = AREA;
    this.subarea = SUBAREA;
    this.displayStyleEditar = "block";
  }

  closePopUpEditar() {
    this.displayStyleEditar = "none";
    this.editarForm.reset();
  }

  editar() {
    this.editarForm.value.AREA = this.area;
    this.editarForm.value.SUBAREA = this.subarea;
    console.log(this.editarForm.value);
    this.api.actualizarAreas(this.editarForm.value).subscribe(res => {
      this.alerts.alertaRealizadoAsistencia('Completado', 'Se ha editado con exito');
      this.closePopUpEditar();
      location.reload();
    })

  }

  //** Promesa para obtener una clave de identificacion de documentos para subirlos a Firebase*/
  getIdentificadorDocumentos = new Promise((resolve, reject) => {
    this.api.obtenerIdentificadorDocumentos(1).subscribe(res => {
      resolve(res.body);  //Cuando se reciben los datos del servidor, resolvemos la promesa
    })
  })

  async changeFileMenu(event: any) {

    let file = event.target.files[0];
    this.archivos[0] = file.name;

    //TODO: Obtenemos nombre identificador para el documento
    this.getIdentificadorDocumentos.then(res => {
      let identificador = res;
      this.subiendoDocumento = true; //Indicamos que se comienza proceso subir foto
      //TODO: Subimos archivo a Firebase


      const name = '- Autlan';

      let path = 'Tramites';  //Construimos ruta
      let fileRef = ref(this.storage, path + '/' + identificador + name + this.archivos[0]); //Creamos una referncia al archivo usando la ruta

      //Subimos el archivo a Firebase
      uploadBytes(fileRef, file).then(response => {
        //TODO: Descargamos la URL del archivo
        getDownloadURL(fileRef).then(file => {
          this.urlDocumento = file; //guardamos la url del archivo en una variable
          this.subiendoDocumento = false;
          console.log(file);

          this.editarForm.value.ICONO = file;
          console.log(this.editarForm.value.ICONO);

        }).catch(error => { console.log(error) });

      })
    })

  }
}
